import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { connect } from "react-redux";
import Axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import SearchForm from "../SearchForm/SearchForm";
import CustomDialog from "../../../../Component/DialogBox/CustomDialog";
import { url } from "../../../../config/config";
import CustomTableHead from "../../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomTableFooter from "../../../../Component/Table/CutomTableFooter/CustomTableFooter";
import { adminLogout } from "../../../../redux/action/action";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import SessionExpiredDialog from "../../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./ViewBookCategory.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";

class ViewBookCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      search: {
        searchCategoryName: "",
      },
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Category Name",
        },
        {
          name: "Category Image",
        },
        {
          name: "Actions",
        },
      ],
      category: [],
      dialogOpen: false,
      categoryToDelete: "",
      isEmpty: false,
      notificationOpen: false,
      sessionExpired: false,
    };
  }

  componentDidMount() {
    this.getCategoryData();
  }

  getCategoryData = async () => {
    try {
      const response = await Axios.get(`${url}/api/categories`);
      if (response.data.length !== 0) {
        this.setState({
          category: response.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          category: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (error.response.data === "Invalid token.") {
        this.setState({ sessionExpired: true });
      }
    }
  };

  handleSearch = (e) => {
    this.setState({
      search: { ...this.state.search, [e.target.name]: e.target.value },
    });
  };

  handleAdd = () => {
    this.props.history.push("/_administration_/category/add");
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  handleDialogOpen = (categoryId) => {
    this.setState({
      dialogOpen: true,
      categoryToDelete: categoryId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleEditCategory = (categoryId) => {
    this.props.history.push(`/_administration_/category/edit/${categoryId}`);
  };

  handleDetailCategory = (categoryId) => {
    this.props.history.push(`/_administration_/category/detail/${categoryId}`);
  };

  handleDeleteCategory = async () => {
    const response = await Axios.delete(
      `${url}/api/categories/${this.state.categoryToDelete}`,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (response.data.success) {
      this.handleDialogClose();
      this.handleNotificationOpen();
      this.getCategoryData();
    }
  };

  showNotification = (notificationStyle) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  render() {
    const { classes } = this.props;
    const { page, rowsPerPage } = this.state;
    const filtered = this.state.category.filter((category) => {
      return (
        category.name
          .toLowerCase()
          .indexOf(this.state.search.searchCategoryName.toLowerCase()) !== -1
      );
    });

    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          {this.state.sessionExpired === true && (
            <SessionExpiredDialog logout={() => this.props.adminLogout()} />
          )}

          <AdminPageTitle title="Book Categories" url={this.props.match.url} />
          <Divider />
          <br />
          <SearchForm
            handleSearch={this.handleSearch}
            search={this.state.search}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IconButton onClick={this.handleAdd} disableRipple>
              <AddCircleIcon style={{ color: "#1c2431" }} />
            </IconButton>
            <div style={{ fontSize: 20, fontWeight: "bold" }}>
              Add New Book Category
            </div>
          </div>
          {this.state.category.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />
                <TableBody>
                  {(rowsPerPage > 0
                    ? filtered.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : filtered
                  ).map((category, index) => (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor: `${index % 2 ? "#eee" : "white"}`,
                      }}
                    >
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">{category.name}</TableCell>
                      <TableCell align="center">
                        <img
                          src={category.imageUrl}
                          alt="categoryImage"
                          style={{ width: 50, height: 50 }}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ alignContent: "center" }}
                      >
                        <Tooltip
                          arrow
                          title="View details"
                          className={classes.tooltip}
                          onClick={() =>
                            this.handleDetailCategory(category._id)
                          }
                        >
                          <InfoIcon />
                        </Tooltip>
                        <Tooltip
                          arrow
                          title="Edit"
                          className={classes.tooltip}
                          onClick={() => this.handleEditCategory(category._id)}
                        >
                          <EditIcon />
                        </Tooltip>
                        <Tooltip
                          arrow
                          title="Delete"
                          className={classes.tooltip}
                          onClick={() => this.handleDialogOpen(category._id)}
                        >
                          <DeleteIcon />
                        </Tooltip>
                      </TableCell>
                      <CustomDialog
                        open={this.state.dialogOpen}
                        handleClose={this.handleDialogClose}
                        handleDelete={this.handleDeleteCategory}
                      />
                    </TableRow>
                  ))}
                </TableBody>
                <CustomTableFooter
                  count={filtered.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
              {this.showNotification(classes.notificationStyle)}
            </TableContainer>
          ) : this.state.isEmpty === true ? (
            <CustomEmptyMessage message="No data present in the database" />
          ) : (
            <CustomLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewBookCategory)));
